import { render, staticRenderFns } from "./delete-file.vue?vue&type=template&id=06c5a40a"
import script from "./delete-file.vue?vue&type=script&lang=js"
export * from "./delete-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports